import React from 'react';
import { useTranslation } from "../../lib/language/useTranslation";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useState } from "react";

let config = {

    "styles": {
      "formContainer": {
        "marginTop": "1.5rem",
        "marginBottom": "1.5rem"
      },
      "formGrid": {
        "display": "grid",
        "gridTemplateColumns": "1fr",
        "gap": "4rem",
        "padding": "2rem",
        "paddingTop": "2rem",
        "maxWidth": "4xl",
        "margin": "0 auto",
        "backgroundColor": "white",
        "boxShadow": "0 2px 10px rgba(6, 81, 237, 0.3)",
        "borderRadius": "0.375rem",
        "color": "#333",
        "fontFamily": "sans-serif"
      },
      "heading": {
        "fontSize": "2rem",
        "fontWeight": "800"
      },
      "subHeading": {
        "fontSize": "0.875rem",
        "color": "#b0b0b0",
        "marginTop": "0.75rem"
      },
      "input": {
        "width": "100%",
        "padding": "0.625rem 1rem",
        "borderRadius": "0.375rem",
        "border": "1px solid #ccc",
        "fontSize": "0.875rem",
        "outlineColor": "#007bff"
      },
      "textarea": {
        "width": "100%",
        "padding": "0.625rem 1rem",
        "borderRadius": "0.375rem",
        "border": "1px solid #ccc",
        "fontSize": "0.875rem",
        "outlineColor": "#007bff"
      },
      "button": {
        "backgroundColor": "#007bff",
        "color": "white",
        "fontWeight": "600",
        "borderRadius": "0.375rem",
        "padding": "0.625rem 1rem",
        "width": "100%",
        "cursor": "pointer"
      },
      "buttonHover": {
        "backgroundColor": "#0062cc"
      },
      "errorText": {
        "color": "#f44336",
        "fontSize": "0.875rem",
        "marginTop": "0.25rem"
      }
    }
  };

const LanguageSelector = ({dialogOn}) => {
  
  const { changeLanguage, loaded } = useTranslation();
  const [selectedLang, setSelectedLang] = useState("");

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedLang(value);
    changeLanguage(value);
  };

  if (!loaded) {
    return null; // or show loading spinner
  }

  return (
    <div style={config.styles.formContainer}>
      <div style={config.styles.formGrid}>
    
      <FormControl fullWidth variant="outlined" size="small">
      <InputLabel id="language-select-label">Select Language</InputLabel>
      <Select
        labelId="language-select-label"
        id="language-select"
        value={selectedLang}
        onChange={handleChange}
        label="Select Language"
      >
      <MenuItem value="af">Afrikaans</MenuItem>
<MenuItem value="sq">Albanian</MenuItem>
<MenuItem value="am">Amharic</MenuItem>
<MenuItem value="ar">Arabic</MenuItem>
<MenuItem value="hy">Armenian</MenuItem>
<MenuItem value="az">Azerbaijani</MenuItem>
<MenuItem value="eu">Basque</MenuItem>
<MenuItem value="be">Belarusian</MenuItem>
<MenuItem value="bn">Bengali</MenuItem>
<MenuItem value="bs">Bosnian</MenuItem>
<MenuItem value="bg">Bulgarian</MenuItem>
<MenuItem value="ca">Catalan</MenuItem>
<MenuItem value="ceb">Cebuano</MenuItem>
<MenuItem value="ny">Chichewa</MenuItem>
<MenuItem value="zh-CN">Chinese (Simplified)</MenuItem>
<MenuItem value="zh-TW">Chinese (Traditional)</MenuItem>
<MenuItem value="co">Corsican</MenuItem>
<MenuItem value="hr">Croatian</MenuItem>
<MenuItem value="cs">Czech</MenuItem>
<MenuItem value="da">Danish</MenuItem>
<MenuItem value="nl">Dutch</MenuItem>
<MenuItem value="en">English</MenuItem>
<MenuItem value="eo">Esperanto</MenuItem>
<MenuItem value="et">Estonian</MenuItem>
<MenuItem value="tl">Filipino</MenuItem>
<MenuItem value="fi">Finnish</MenuItem>
<MenuItem value="fr">French</MenuItem>
<MenuItem value="fy">Frisian</MenuItem>
<MenuItem value="gl">Galician</MenuItem>
<MenuItem value="ka">Georgian</MenuItem>
<MenuItem value="de">German</MenuItem>
<MenuItem value="el">Greek</MenuItem>
<MenuItem value="gu">Gujarati</MenuItem>
<MenuItem value="ht">Haitian Creole</MenuItem>
<MenuItem value="ha">Hausa</MenuItem>
<MenuItem value="haw">Hawaiian</MenuItem>
<MenuItem value="iw">Hebrew</MenuItem>
<MenuItem value="hi">Hindi</MenuItem>
<MenuItem value="hmn">Hmong</MenuItem>
<MenuItem value="hu">Hungarian</MenuItem>
<MenuItem value="is">Icelandic</MenuItem>
<MenuItem value="ig">Igbo</MenuItem>
<MenuItem value="id">Indonesian</MenuItem>
<MenuItem value="ga">Irish</MenuItem>
<MenuItem value="it">Italian</MenuItem>
<MenuItem value="ja">Japanese</MenuItem>
<MenuItem value="jw">Javanese</MenuItem>
<MenuItem value="kn">Kannada</MenuItem>
<MenuItem value="kk">Kazakh</MenuItem>
<MenuItem value="km">Khmer</MenuItem>
<MenuItem value="ko">Korean</MenuItem>
<MenuItem value="ku">Kurdish (Kurmanji)</MenuItem>
<MenuItem value="ky">Kyrgyz</MenuItem>
<MenuItem value="lo">Lao</MenuItem>
<MenuItem value="la">Latin</MenuItem>
<MenuItem value="lv">Latvian</MenuItem>
<MenuItem value="lt">Lithuanian</MenuItem>
<MenuItem value="lb">Luxembourgish</MenuItem>
<MenuItem value="mk">Macedonian</MenuItem>
<MenuItem value="mg">Malagasy</MenuItem>
<MenuItem value="ms">Malay</MenuItem>
<MenuItem value="ml">Malayalam</MenuItem>
<MenuItem value="mt">Maltese</MenuItem>
<MenuItem value="mi">Maori</MenuItem>
<MenuItem value="mr">Marathi</MenuItem>
<MenuItem value="mn">Mongolian</MenuItem>
<MenuItem value="my">Myanmar (Burmese)</MenuItem>
<MenuItem value="ne">Nepali</MenuItem>
<MenuItem value="no">Norwegian</MenuItem>
<MenuItem value="ps">Pashto</MenuItem>
<MenuItem value="fa">Persian</MenuItem>
<MenuItem value="pl">Polish</MenuItem>
<MenuItem value="pt">Portuguese</MenuItem>
<MenuItem value="pa">Punjabi</MenuItem>
<MenuItem value="ro">Romanian</MenuItem>
<MenuItem value="ru">Russian</MenuItem>
<MenuItem value="sm">Samoan</MenuItem>
<MenuItem value="gd">Scots Gaelic</MenuItem>
<MenuItem value="sr">Serbian</MenuItem>
<MenuItem value="st">Sesotho</MenuItem>
<MenuItem value="sn">Shona</MenuItem>
<MenuItem value="sd">Sindhi</MenuItem>
<MenuItem value="si">Sinhala</MenuItem>
<MenuItem value="sk">Slovak</MenuItem>
<MenuItem value="sl">Slovenian</MenuItem>
<MenuItem value="so">Somali</MenuItem>
<MenuItem value="es">Spanish</MenuItem>
<MenuItem value="su">Sundanese</MenuItem>
<MenuItem value="sw">Swahili</MenuItem>
<MenuItem value="sv">Swedish</MenuItem>
<MenuItem value="tg">Tajik</MenuItem>
<MenuItem value="ta">Tamil</MenuItem>
<MenuItem value="te">Telugu</MenuItem>
<MenuItem value="th">Thai</MenuItem>
<MenuItem value="tr">Turkish</MenuItem>
<MenuItem value="uk">Ukrainian</MenuItem>
<MenuItem value="ur">Urdu</MenuItem>
<MenuItem value="uz">Uzbek</MenuItem>
<MenuItem value="vi">Vietnamese</MenuItem>
<MenuItem value="cy">Welsh</MenuItem>
<MenuItem value="xh">Xhosa</MenuItem>
<MenuItem value="yi">Yiddish</MenuItem>
<MenuItem value="yo">Yoruba</MenuItem>
<MenuItem value="zu">Zulu</MenuItem>

        {/* You can add more languages here */}
      </Select>
    </FormControl>
         
      </div>
    </div>
  );
};

export default LanguageSelector;
